import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container-padded max-w-3xl mx-auto">
      <div className="card text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-secondary-500">404</p>
        <h1 className="mt-3 text-3xl font-bold text-secondary-900 dark:text-secondary-100">
          Pagina niet gevonden
        </h1>
        <p className="mt-2 text-secondary-600 dark:text-secondary-300">
          De pagina bestaat niet of je hebt geen toegang.
        </p>
        <Link to="/" className="btn-primary mt-6 inline-flex">
          Terug naar start
        </Link>
      </div>
    </div>
  );
}
